

export const PostAPI = async (apiAxios, url, json) => {
    try {

        const response = await apiAxios.post(url, json);

        if (response.status === 200 || response.status === 201) {
            if (response.data.sucesso === "SIM") {
                return {
                    success: true,
                    data: response.data.data,
                    errorMessage: "",
                };
            } else {
                return {
                    success: false,
                    data: null,
                    errorMessage: response.data?.data || "Erro na resposta da API.",
                };
            }
        } else {
            return {
                success: false,
                data: null,
                errorMessage: response.data?.data || "Erro inesperado.",
            };
        }
    } catch (err) {
        return {
            success: false,
            data: null,
            errorMessage: err?.response?.data?.data || "Erro na comunicação com o servidor.",
        };
    }
};
